<template>
  <span>{{ convertedValue }}</span>
</template>

<script>

export default {
  name: 'ZeroDash',
  props: {
    value: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    convertedValue: function () {
      return this.value === 0 ? '-' : this.value
    },
  },
}

</script>
